import { render } from "./DataManager.vue?vue&type=template&id=a60acaea&scoped=true"
import script from "./DataManager.vue?vue&type=script&lang=js"
export * from "./DataManager.vue?vue&type=script&lang=js"

import "./DataManager.vue?vue&type=style&index=0&id=a60acaea&scoped=true&lang=css"

import exportComponent from "/home/runner/work/dendro-plots/dendro-plots/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a60acaea"]])

export default __exports__